module.exports = __webpack_public_path__ + "img/Exit.44e82c23.svg";